module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-243.3113a7da.svg";